"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const defaultTheme_1 = require("../defaultTheme");
exports.default = () => {
    const { mobile, desktop, tablet, phoneMini } = defaultTheme_1.defaultTheme.utils.breakpoints;
    const checkPhoneMini = (w) => w < parseInt(phoneMini);
    const checkMobile = (w) => w < parseInt(mobile);
    const checkDesktop = (w) => w >= parseInt(desktop);
    const checkTablet = (w) => w >= parseInt(tablet) && w < parseInt(desktop);
    const wH = window.innerWidth;
    const [isPhoneMini, setIsPhoneMini] = (0, react_1.useState)(checkPhoneMini(wH));
    const [isMobile, setIsMobile] = (0, react_1.useState)(checkMobile(wH));
    const [isDesktop, setIsDesktop] = (0, react_1.useState)(checkDesktop(wH));
    const [isTablet, setIsTablet] = (0, react_1.useState)(checkTablet(wH));
    const stateUpdate = (w) => {
        setIsPhoneMini(checkPhoneMini(w));
        setIsMobile(checkMobile(w));
        setIsDesktop(checkDesktop(w));
        setIsTablet(checkTablet(w));
    };
    (0, react_1.useEffect)(() => {
        const handleResize = () => {
            stateUpdate(window.innerWidth);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return { isMobile, isDesktop, isTablet, isPhoneMini };
};
//# sourceMappingURL=useRWD.js.map